import Markdown from "../componentes/markdownwww";
import React, { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
import 'katex/dist/katex.min.css';
// import Modal from 'react-modal'




<ToastContainer
  position="bottom-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false}
/>







export function Newsww({ descripcion }) {


  // const [userforo, setUserforo] = useState(tipo)
  const [show, setShow] = useState()
  const [title, setTitle] = useState()
  const [description, setDescription] = useState()

  useEffect(() => {
    setDescription(descripcion)
    // setTitle(tipo == 'create' ? '' : titulo)
    // setIdforo(idfore)
    // setType(tipo)
    // setIdnew(idneww)
    // setShow(shhow)
    // setEdit(editar)
  }, []);

  const clean = async () => {
    setTitle('')
    setDescription('')
    // setEdit('')
    // setType('')
    // setIdforo('')
  }



  return (
    <Markdown>{description ? description.replace(/(<oembed url="https:\/\/www.dailymotion.com\/video\/)(.*?)(".*?oembed>)/g, `<iframe height='350' src="https://www.dzilymotion.com/embed/video/$2"></iframe>`).replace(/(<oembed url="https:\/\/www.youtube.com\/watch\?v=)(.*?)(".*?oembed>|&.*?oembed>)/g, `<iframe height='350' src="https://www.youtube.com/embed/$2"></iframe>`).replace(/(<script type="math\/tex; mode=display">)(.*?)(<\/script>)/g, "\n$$$$\n$2\n$$$$\n").replace(/(<script type="math\/tex">)(.*?)(<\/script>)/g, "$$$2$$").replace(/(<p>nbsp;<\/p>)/g, "").replace(/(<p>)/g, " \n").replace(/(<\/p>)/g, " \n").replace(/(<h2>)/g, "# ").replace(/(<\/h2>)/g, "\n ").replace(/(<h3>)/g, "## ").replace(/(<\/h3>)/g, "\n ").replace(/(<h4>)/g, "### ").replace(/(<\/h4>)/g, "\n ").replace(/(<figure>)/g, " \n").replace(/(<\/figure>)/g, "\n").replace(/(<li>)/g, "\n 1. ").replace(/(<\/li>)/g, "").replace(/(<ol>)/g, "").replace(/(<\/ol>)/g, "\n").replace(/(<ul>)/g, "").replace(/(<\/ul>)/g, "\n").replace(/(<blockquote>)/g, "\n > ").replace(/(<\/blockquote>)/g, "\n\n ").replace(/<a href="(.*?)">(.*?)(<\/a>)/g, "[$2]($1)"):""}
    </Markdown>
  );
}

